import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { PartStatusList } from "../helpers/parts";

import axios from "../helpers/axios";

const BackOrderClient = () => {

  let color = 'white';
  const site = process.env.REACT_APP_SITE
  const backgroundColor = process.env.REACT_APP_PRIMARY_COLOR
  if (site == 'tracsa.com.mx'){
    color='black'
  }

  const [documents, setDocuments] = useState({ results: 0 });
  const [search, setSearch] = useState(() => {
    if (window.location.hash) {
      return window.location.hash.substring(1).toUpperCase();
    }

    return "";
  });

  const [isLoading, setLoading] = useState(false);
  const [is404, set404] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    // Store query in location
    window.location.hash = search;

    // Load results
    loadData(search);
  };

  const loadData = (query) => {
    setLoading(true);

    let url_documents = `https://tracking.${site}/api/backorders-paginated/`;

    if(query.length <=7 ){
      console.info('by client');
      url_documents = `https://tracking.${site}/api/backorders-by-client-paginated/`;

    }else{
      console.info('by document');
    }
    console.log(url_documents);

    axios
    .get(url_documents, {
        params: { search: query, limit: 10, ordering: '-endt8' },
      })
      .then((response) => {
        const { data } = response;
        if (response.status !== 200 || data.length === 0) {
          setDocuments({});
          set404(true);
          alert()
        } else {
          setData(data);
        }
      })
      .catch((err) => {
        console.log("Error:", err);

        setDocuments({});
        set404(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function setData(data) {
    data.results.forEach((element) => {
      let textStatus = "";
      let arrayStatus = [];
      const date = element.endt8.split('T');
      element.date = date[0];
      element.parts.forEach((part, index) => {
        if (!arrayStatus.includes(part.status)) {
          const psIndex = PartStatusList.find(
            (item) => item.id === part.status
          );
          textStatus +=
            "<p class='" + psIndex.color + "'>" + psIndex.label + "<p>";
          arrayStatus.push(part.status);
        }
        element.textStatus = textStatus;
      });
    });
    setDocuments(data);
    set404(false);
  }

  function loadMoreData(value) {
    const separate = value.split("//");
    const result = "https://" + separate[1];
    axios
      .get(result)
      .then((response) => {
        const { data } = response;
        if (response.status !== 200 || data.length === 0) {
          setDocuments({});
          set404(true);
        } else {
          setData(data);
        }
      })
      .catch((err) => {
        console.log("Error:", err);

        setDocuments({ results: 0 });
        set404(true);
      });
  }

  useEffect(() => {
    if (search) {
      loadData(search);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let content = null;
  if (isLoading) {
    content = (
      <section className="hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title">Cargando</h1>
            <h2 className="subtitle">Sincronizando documento</h2>
          </div>
        </div>
      </section>
    );
  } else if (is404) {
    content = (
      <section className="hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title">Sin resultados</h1>
            <h2 className="subtitle">La búsqueda no arrojó ningún resultado</h2>
          </div>
        </div>
      </section>
    );
  } else if (documents.results.length > 0) {
    content = (
      <div
        className="container"
        style={{
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          marginTop: "3rem",
        }}
      >
        <div className="card">
          <table className="table is-striped is-fullwidth has-text-grey">
            <thead>
              <tr>
                <th>Documento</th>
                <th>Cliente</th>
                <th>Fecha de pedido</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              {documents.results.map((document, index) => (
                <tr key={index}>
                  <td>
                    <Link to={`/order/${document.rfdcno}`}>
                      {document.rfdcno}
                    </Link>
                  </td>
                  <td>{document.cuno}</td>
                  <td>{document.date}</td>
                  <td
                    dangerouslySetInnerHTML={{ __html: document.textStatus }}
                  ></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          className="contentButtons"
          style={{
            marginTop: "3rem",
            display: "flex",
            justifyContent: "right",
          }}
        >
          <button
            disabled={!documents.previous}
            onClick={() => loadMoreData(documents.previous)}
            style={{
              backgroundColor: backgroundColor,
              color: color,
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
              fontSize: "27px",
              width: "34px",
            }}
          >
            <p>&#x2039;</p>
          </button>
          <button
            disabled={!documents.next}
            onClick={() => loadMoreData(documents.next)}
            style={{
              backgroundColor: backgroundColor,
              color: color,
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
              marginLeft: "10px",
              fontSize: "27px",
              width: "34px",
            }}
          >
            &#x203A;
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#f0f4f5",
        backgroundImage: "url(/backscreen.png)",
        backgorundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
        padding: "20px",
      }}
    >
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="field has-addons" style={{ paddingTop: "3rem" }}>
            <div className="control is-expanded">
              <input
                className="input is-large"
                type="text"
                placeholder="Buscar número de cliente o documento"
                value={search}
                onChange={(event) =>
                  setSearch(event.target.value.toUpperCase())
                }
              />
            </div>
            <div className="control">
              <button className="button is-large is-primary">
                <FontAwesomeIcon icon={["fas", "search"]} />
                &nbsp; Buscar
              </button>
            </div>
          </div>
        </form>
      </div>
      {content}
    </div>
  );
};

export default BackOrderClient;
